<script lang="ts">
	import WebGeneralLayout from "./WebGeneralLayout.svelte";
	
	import ReverieLib from "@ludans/reverie";

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const hashInUrl = urlParams.get("hash");

	let hash: string = hashInUrl || ReverieLib.randomHash();

</script>

<WebGeneralLayout {hash}/>
